import { MapPin } from "lucide-react";

// Live seat-availability banner shown above the registration form.
export const SeatsBanner = ({ seats }) => {
  if (!seats || seats.remaining <= 0) return null;
  const seatPct = seats.capacity ? Math.min(100, Math.round((seats.taken / seats.capacity) * 100)) : 0;
  const urgent = seats.remaining <= 15;
  return (
    <div className={`crl-seats${urgent ? " crl-seats--urgent" : ""}`} data-testid="seats-remaining" role="status" aria-live="polite">
      <span className="crl-seats__pulse" aria-hidden="true" />
      <div className="crl-seats__text">
        <strong data-testid="seats-remaining-count">
          {urgent ? `Only ${seats.remaining} seats left` : `${seats.remaining} seats remaining`}
        </strong>
        <span>Limited capacity at Capital Group · reserve yours now</span>
      </div>
      <span className="crl-seats__badge" data-testid="seats-reserved-pct" aria-hidden="true">{seatPct}% reserved</span>
      <div className="crl-seats__bar" aria-hidden="true">
        <i style={{ width: `${seatPct}%` }} />
      </div>
    </div>
  );
};

// Venue address + embedded map + directions link.
export const VenueCard = ({ event }) => (
  <div className="crl-venue" data-testid="venue-map-card">
    <div className="crl-venue__head">
      <span className="crl-venue__pin"><MapPin size={16} /></span>
      <div>
        <p className="crl-venue__eyebrow">Venue</p>
        <p className="crl-venue__name" data-testid="venue-name">{event.venueLine1}</p>
        <p className="crl-venue__line">{event.venueLine2}</p>
        <p className="crl-venue__line">{event.venueLine3}</p>
      </div>
    </div>
    <div className="crl-venue__map">
      <iframe
        title="Seminar venue location map"
        data-testid="venue-map-iframe"
        src={event.mapEmbedUrl}
        width="100%"
        height="180"
        style={{ border: 0, display: "block" }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
      />
    </div>
    <a className="crl-venue__link" href={event.mapLinkUrl} target="_blank" rel="noopener noreferrer" data-testid="venue-directions-link">
      <MapPin size={14} /> Get directions
    </a>
  </div>
);
